export default {
    "cancel": "Cancelar",
    "vanAddressEditDetail": {
        "label": "Dirección",
        "placeholder": "Número de calle, número de habitación del piso, etc."
    },
    "save": "ahorrar",
    "vanAddressList": {
        "add": "añadir dirección"
    },
    "delete": "Eliminar",
    "telInvalid": "Por favor ingrese el número de teléfono correcto",
    "tel": "Teléfono",
    "telEmpty": "Por favor complete el número de teléfono",
    "nameEmpty": "Por favor, ponga su nombre",
    "vanCoupon": {
        "unlimited": "sin restricciones de uso"
    },
    "lang": "中文",
    "vanCalendar": {
        "startEnd": "inicio fin",
        "weekdays": [
            "Día",
            "Uno",
            "Dos",
            "Tres",
            "Cuatro",
            "Cinco",
            "Seis"
        ],
        "start": "comienzo",
        "title": "título",
        "confirm": "confirmar",
        "end": "Finalizar"
    },
    "vanSubmitBar": {
        "label": "todos:"
    },
    "vanContactCard": {
        "addText": "Añadir contactos"
    },
    "loading": "Cargando...",
    "vanCascader": {
        "select": "por favor elige"
    },
    "confirmDelete": "estas seguro que quieres borrarlo",
    "vanContactList": {
        "addText": "nuevo contacto"
    },
    "confirm": "confirmar",
    "vanCouponCell": {
        "title": "cupón",
        "tips": "No disponible"
    },
    "vanPullRefresh": {
        "loosing": "liberar actualizar...",
        "pulling": "Tire hacia abajo para refrescar..."
    },
    "nameInvalid": "Por favor ingrese un nombre valido",
    "name": "Nombre",
    "vanPagination": {
        "next": "siguiente página",
        "prev": "pagina anterior"
    },
    "vanCouponList": {
        "empty": "sin cupón",
        "enable": "usable",
        "disabled": "No disponible",
        "exchange": "intercambio",
        "placeholder": "Por favor, introduzca el código de promoción",
        "close": "sin cupón"
    },
    "vanAddressEdit": {
        "area": "área",
        "namePlaceholder": "Nombre del destinatario",
        "telPlaceholder": "Número de teléfono móvil del consignatario",
        "areaEmpty": "seleccione región",
        "postalEmpty": "Formato de código postal incorrecto",
        "addressEmpty": "Por favor complete la dirección detallada",
        "postal": "código postal",
        "areaPlaceholder": "Selecciona Provincia/Ciudad/Región",
        "defaultAddress": "Establecer como dirección de envío predeterminada"
    },
    "complete": "Finalizar"
}